import { render, staticRenderFns } from "./Registers.yaml?vue&type=template&id=fc401408&component"
import script from "./Registers.yaml?vue&type=script&lang=ts&component"
export * from "./Registers.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports